import React, { FC } from 'react';

import { ListCardGroup } from 'components/list-card-group';
import { t } from 'state/intl/translations';

import { Modifier } from '../modifier';
import { IModifierData } from '../modifier/types';

import { IModifierGroupProps } from './types';

export const ModifierGroup: FC<IModifierGroupProps> = ({
  displayGroupName,
  modifiers,
  onModifierSelectionChange,
  selectedItem,
}) => {
  return (
    <ListCardGroup
      items={modifiers}
      header={displayGroupName !== 'chooseItemAmount' ? t(displayGroupName) : undefined}
      renderItem={({ item: modifierProps }: { item: IModifierData }) => {
        return (
          <Modifier
            key={`modifier-${modifierProps.modifier.name?.locale}`}
            {...modifierProps}
            onSelectionsChange={selections =>
              onModifierSelectionChange(selections, modifierProps.modifier)
            }
            selectedItem={selectedItem}
          />
        );
      }}
    />
  );
};
